import { Link } from 'react-router-dom';

/**
 * Política de privacidad pública. Google exige una URL de política de
 * privacidad para publicar la app de OAuth ("Ingresar con Google"); además
 * es lo que corresponde para el personal y los clientes que cargan sus datos.
 * Texto en lenguaje simple; Fernando puede ajustarlo desde acá.
 */
export function PrivacidadPage() {
  return (
    <div className="min-h-full bg-superficie px-4 py-8">
      <article className="mx-auto max-w-2xl space-y-5 rounded-2xl bg-white p-6 shadow-sm border border-contorno-var text-sm text-neutro-700">
        <header>
          <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-contorno">CONVOCA</p>
          <h1 className="text-2xl font-bold text-neutro-800">Política de privacidad</h1>
          <p className="text-xs text-neutro-400">Última actualización: 13 de septiembre de 2026</p>
        </header>

        <section className="space-y-2">
          <h2 className="font-semibold text-neutro-800">Quiénes somos</h2>
          <p>
            CONVOCA es la plataforma con la que una empresa de personal gastronómico de Montevideo (Uruguay)
            coordina cocineros, mozos y ayudantes con los establecimientos que los contratan. Este sitio y la
            app del personal son de uso privado: solo entran las personas y clientes que la empresa da de alta.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-semibold text-neutro-800">Qué datos guardamos</h2>
          <ul className="list-disc space-y-1 pl-5">
            <li><strong>Del personal:</strong> nombre, cédula, teléfono, email, categorías de trabajo, disponibilidad, turnos trabajados, marcas de asistencia (incluida la ubicación GPS en el momento del check-in) y liquidaciones.</li>
            <li><strong>De los clientes:</strong> razón social, RUT, contactos, salones, solicitudes de personal y facturación.</li>
            <li><strong>De la cuenta:</strong> email, contraseña (guardada solo como hash, nunca en claro), fecha y origen de cada inicio de sesión y, si usás "Ingresar con Google", el identificador de tu cuenta de Google y tu email verificado. No accedemos a tus contactos, calendario ni a ningún otro dato de Google.</li>
          </ul>
        </section>

        <section className="space-y-2">
          <h2 className="font-semibold text-neutro-800">Para qué los usamos</h2>
          <p>
            Únicamente para operar el servicio: convocar personal a los eventos, registrar asistencia, liquidar pagos,
            facturar a los clientes y avisarte por notificación de novedades sobre tus convocatorias. No vendemos ni
            cedemos datos a terceros con fines comerciales.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-semibold text-neutro-800">Dónde están y quién los ve</h2>
          <p>
            Los datos se almacenan en la infraestructura de Cloudflare. Los ve la empresa administradora, el propio
            usuario (sus datos) y el cliente (solo los servicios que contrató). Para validar contraseñas nuevas
            consultamos el servicio Have I Been Pwned sin enviar nunca la contraseña (solo una parte del hash).
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-semibold text-neutro-800">Tus derechos</h2>
          <p>
            Podés pedir ver, corregir o eliminar tus datos, o dar de baja tu cuenta, escribiendo al administrador
            de la empresa o a <a className="text-primario-500 underline" href="mailto:fernando@convoca.uy">fernando@convoca.uy</a>.
            Las bajas se hacen de forma lógica para conservar el historial de servicios y pagos que exige la normativa laboral y fiscal uruguaya.
          </p>
        </section>

        <footer className="pt-2 text-xs text-neutro-400">
          <Link to="/login" className="underline">Volver al inicio de sesión</Link>
        </footer>
      </article>
    </div>
  );
}
